// TSS Product Card gallery arrows
// Uses event delegation so it works for every product card on the page,
// including cards added later (infinite scroll / pagination).
console.log('[TSS] card gallery script loaded');

(function () {
  if (window.__tssCardGalleryInit) return;
  window.__tssCardGalleryInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tss-card-nav');
    if (!btn) return;

    console.log('[TSS] arrow clicked', btn);

    e.preventDefault();
    e.stopPropagation();

    var cardMedia = btn.closest('.card__media, use-animate, .card');
    console.log('[TSS] cardMedia found:', cardMedia);
    if (!cardMedia) return;

    // Ignore clicks while a slide is already in progress, so rapid
    // clicking can't start a second animation on top of the first
    // and leave images in a half-transitioned state.
    if (cardMedia.__tssAnimating) return;

    var images = cardMedia.querySelectorAll('.tss-gallery-img');
    console.log('[TSS] images found:', images.length);
    if (images.length < 2) return;

    var currentIndex = 0;
    images.forEach(function (img, i) {
      if (img.classList.contains('is-active')) currentIndex = i;
    });

    var isNext = btn.classList.contains('tss-card-nav--next');
    var nextIndex = isNext
      ? (currentIndex + 1) % images.length
      : (currentIndex - 1 + images.length) % images.length;

    if (nextIndex === currentIndex) return;

    console.log('[TSS] switching from', currentIndex, 'to', nextIndex);

    var currentImg = images[currentIndex];
    var nextImg = images[nextIndex];

    // Clicking "next": the current image slides out to the LEFT and
    // the incoming image slides in FROM the right.
    // Clicking "prev": the reverse.
    var exitClass = isNext ? 'tss-slide-exit-left' : 'tss-slide-exit-right';
    var enterFromClass = isNext ? 'tss-slide-enter-from-right' : 'tss-slide-enter-from-left';

    cardMedia.__tssAnimating = true;

    // Place the incoming image off-screen on the correct side first,
    // with transitions off, so there's no visible jump before the
    // slide starts.
    nextImg.classList.add('is-active', enterFromClass);

    // Force the browser to register that starting position before we
    // switch on the transition — otherwise the browser may batch both
    // class changes into one paint and skip the animation entirely.
    void nextImg.offsetWidth;

    currentImg.classList.add(exitClass);
    nextImg.classList.remove(enterFromClass);
    nextImg.classList.add('tss-slide-enter-active');

    var cleanup = function (evt) {
      // transitionend fires once per animated property per element;
      // only react to the transform we actually care about.
      if (evt && evt.propertyName && evt.propertyName !== 'transform') return;
      currentImg.classList.remove('is-active', exitClass);
      nextImg.classList.remove('tss-slide-enter-active');
      cardMedia.__tssAnimating = false;
      nextImg.removeEventListener('transitionend', cleanup);
    };

    nextImg.addEventListener('transitionend', cleanup);
  });
})();